module.exports = __webpack_public_path__ + "static/img/AdobeStock_317642059.7c3d8fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_design/AdobeStock_317642059.png
// module id = 125
// module chunks = 1